import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sec2-as3',
  templateUrl: './sec2-as3.component.html',
  styleUrls: ['./sec2-as3.component.css']
})
export class Sec2As3Component implements OnInit {
  showPassword = false;
  clickLog = [];

  constructor() { }

  ngOnInit(): void {
  }

  displayDetails(){
    /*
    if(this.showPassword === false){
      this.showPassword = true;
    } else {
      this.showPassword = false;
    }
    */
   this.showPassword = !this.showPassword;

    this.clickLog.push(this.clickLog.length+1);
    console.log(this.clickLog)
  }

  getColor(){
    return this.clickLog.length >= 5 ? 'blue' : '';
  }
}
